module.exports = "/_next/static/images/48144a3f6f9d0e44208424700fc42400-about-us-hero.jpg.webp";